import React from 'react'

import clsx from 'clsx'

import Grid, { Container } from 'components/Grid'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { getTagInfo, SPECIAL_TAGS } from 'screens/serp/helpers/enhnacedContent'

import GetListBanner from '../GetListBanner'
import Methodology from './components/Methodology'

import classes from './Top4.module.scss'

/** @type {import("./types").default} */
const Top4 = ({ className, listings, category, facet }) => {
  const currentFacet = facet.label.toLowerCase()
  const { addEvent } = useEventContext({
    engagementComponent: 'link-to_full-list',
  })

  const handleSmoothScrollToOther = evt => {
    evt.preventDefault()
    const targetId = 'other'
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }

  const handleSmoothScrollToProduct = (evt, product) => {
    evt.preventDefault()
    const targetId = `listing-${product.slug}`
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }

  return (
    <Grid className={clsx('Top4', classes.root, className)}>
      <Container>
        <ul className={classes.list}>
          {listings.map(listing => (
            <Link
              key={`best-product_${listing.slug}`}
              component="li"
              disableSeo={false}
              onClick={e => handleSmoothScrollToProduct(e, listing)}
              className={classes.item}
            >
              {listing.name}

              {listing?.highly_rated_for && !SPECIAL_TAGS[listing?.highly_rated_for] && (
                <span className={classes.ratingText}>
                  {' '}
                  - {getTagInfo(listing.highly_rated_for, { skipSpecial: true }).label}
                </span>
              )}
            </Link>
          ))}
        </ul>
      </Container>

      <Typography>
        See other top{' '}
        <Link
          component="span"
          disableSeo={false}
          onClick={handleSmoothScrollToOther}
          {...addEvent({
            engagementDetails: 'textlink_go-to_full-list',
            engagementDestination: 'go-to_full-list',
            name: 'engagement_navigation',
          })}
        >
          <strong>
            {category.name} products with {currentFacet}
          </strong>
        </Link>
      </Typography>

      <GetListBanner />
      <Methodology facet={currentFacet} category={category.name} listings={listings} />
    </Grid>
  )
}

export default Top4
